import { DOCUMENT, effect, inject, Injectable } from '@angular/core';
import { GlobalStore, Theme } from './global.store';

const DARK_LINK_ID = 'mds-dark-theme';
const DARK_HREF = 'dark-theme.css';
const THEME_ATTR = 'data-theme';

@Injectable({ providedIn: 'root' })
export class ThemeApplier {
  private readonly doc = inject(DOCUMENT);
  private readonly globalStore = inject(GlobalStore);

  constructor() {
    effect(() => {
      this.apply(this.globalStore.theme());
    });
  }

  private apply(theme: Theme): void {
    const root = this.doc.documentElement;
    root.setAttribute(THEME_ATTR, theme);

    const existing = this.doc.getElementById(DARK_LINK_ID) as HTMLLinkElement | null;
    if (theme === 'dark') {
      if (!existing) {
        const link = this.doc.createElement('link');
        link.id = DARK_LINK_ID;
        link.rel = 'stylesheet';
        link.href = DARK_HREF;
        this.doc.head.appendChild(link);
      }
    } else if (existing) {
      existing.remove();
    }
  }
}
